import React from 'react';

const PageContent = () => {

    return (
        <div className="section">
            <h2>Page Content</h2>
        </div>
    );
};

export default PageContent;
